import { render, staticRenderFns } from "./AddTimetableRecord.vue?vue&type=template&id=13930575&"
import script from "./AddTimetableRecord.vue?vue&type=script&lang=js&"
export * from "./AddTimetableRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports